export enum ReactQueryKeys {
  // Cart
  CART = 'cart',
  // Checkout
  CHECKOUT = 'checkout',
  // Checkout
  CHECKOUT_TERMINAL_AM = 'checkout-terminal-am',
  // Checkout AM
  CHECKOUT_AM = 'checkout-am',
  // Cart AM
  CART_PAYMENT_AM = 'cart-payment-am',
  // Status check for terminal
  PAYMENT_TERMINAL_STATUS = 'payment-terminal-status',
  // Resend verification email
  RESEND_EMAIL = 'resend-email',
  // get mint redirect url
  MINT_REDIRECT_URL = 'mint-redirect-url',
  // get merchandise products
  MERCHANDISE_PRODUCTS = 'merchandise-products',
  COLLECTIONS_SLIDER = 'collections-slider',
  // omni serach tab
  SEARCH_NFT_LIST = 'search-nft-list',
  SEARCH_COLLECTION_LIST = 'search-collection-list',
  SEARCH_CREATOR_LIST = 'search-creator-list',
  // TransactionFee
  TRANSACTION_FEE = 'transaction-fee',
  // service fee
  SERVICE_FEE = 'service-fee'
}
